module.exports = function (left, operator, right, options) {
  return handlebarsIfCond.call(this, left, operator, right, options);
};
